import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const Faq = () => {
  return (
    <div>
      <Navbar />
      <h1>FAQ</h1>
      <Footer />
    </div>
  )
}

export default Faq
